import { URL, handleErrors } from "./depannageActions"
import { catchApiError } from "./apiHelpers"

// Slice de l'écran /location/gerer : flotte de location (Vehicule moderne) +
// calendrier "vue d'ensemble" (range) + locations en retard (checkLocationsLate,
// rapatrié ici à la purge des pages location legacy).

export const FETCH_LOCATION_FLEET_BEGIN = "FETCH_LOCATION_FLEET_BEGIN"
export const FETCH_LOCATION_FLEET_SUCCESS = "FETCH_LOCATION_FLEET_SUCCESS"
export const FETCH_LOCATION_FLEET_ERROR = "FETCH_LOCATION_FLEET_ERROR"

export const FETCH_LOCATION_CALENDAR_BEGIN = "FETCH_LOCATION_CALENDAR_BEGIN"
export const FETCH_LOCATION_CALENDAR_SUCCESS = "FETCH_LOCATION_CALENDAR_SUCCESS"
export const FETCH_LOCATION_CALENDAR_ERROR = "FETCH_LOCATION_CALENDAR_ERROR"

export function fetchLocationFleet() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: FETCH_LOCATION_FLEET_BEGIN })
		return fetch(`${URL}api/location/fleet`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) =>
				dispatch({
					type: FETCH_LOCATION_FLEET_SUCCESS,
					payload: { fleet: json },
				}),
			)
			.catch(
				catchApiError(dispatch, (error) => ({
					type: FETCH_LOCATION_FLEET_ERROR,
					payload: { error },
				})),
			)
	}
}

// kwargs : { start: "YYYY-MM-DD", end: "YYYY-MM-DD", vehicule?: number }
export function fetchLocationCalendar({ start, end, vehicule = 0 }) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: FETCH_LOCATION_CALENDAR_BEGIN })
		const url = `${URL}api/location/calendar?start=${start}&end=${end}&vehicule=${vehicule}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) =>
				dispatch({
					type: FETCH_LOCATION_CALENDAR_SUCCESS,
					payload: { events: json.events || [] },
				}),
			)
			.catch(
				catchApiError(dispatch, (error) => ({
					type: FETCH_LOCATION_CALENDAR_ERROR,
					payload: { error },
				})),
			)
	}
}

export const CHECK_LOCATIONS_LATE_BEGIN = "CHECK_LOCATIONS_LATE_BEGIN"
export const CHECK_LOCATIONS_LATE_ERROR = "CHECK_LOCATIONS_LATE_ERROR"
export const CHECK_LOCATIONS_LATE_SUCCESS = "CHECK_LOCATIONS_LATE_SUCCESS"

export function checkLocationsLate() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: CHECK_LOCATIONS_LATE_BEGIN })
		return fetch(`${URL}api/locationchecker`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) =>
				dispatch({
					type: CHECK_LOCATIONS_LATE_SUCCESS,
					payload: { lateLocs: json.lateLocs },
				}),
			)
			.catch(
				catchApiError(dispatch, (error) => ({
					type: CHECK_LOCATIONS_LATE_ERROR,
					payload: { error },
				})),
			)
	}
}
